import { AnalyticsNonInteractiveEventObjectException } from '../errors/analytics-error';
import Logger from '../utils/analytics-logger';
import DataObject from './data-object';

export default class NonInteractiveEventObject extends DataObject {
  constructor(data) {
    super('nievent', data);

    if (!data.category) {
      Logger.error(
        "[AnalyticsNonInteractiveEventObjectException] Category is required for nievent (L'Oréal guideline)",
        data,
      );
      throw new AnalyticsNonInteractiveEventObjectException(
        "Category is required for nievent (L'Oréal guideline)",
      );
    }

    if (!data.action) {
      Logger.error(
        "[AnalyticsNonInteractiveEventObjectException] Action is required for nievent (L'Oréal guideline)",
        data,
      );
      throw new AnalyticsNonInteractiveEventObjectException(
        "Action is required for nievent (L'Oréal guideline)",
      );
    }

    if (!data.label) {
      Logger.error(
        "[AnalyticsNonInteractiveEventObjectException] Label is required for nievent (L'Oréal guideline)",
        data,
      );
      throw new AnalyticsNonInteractiveEventObjectException(
        "Label is required for nievent (L'Oréal guideline)",
      );
    }
  }

  set category(category) {
    this.result.eventCategory = this.setProperty(category);
  }

  get category() {
    return this.result.eventCategory;
  }

  set action(action) {
    this.result.eventAction = this.setProperty(action);
  }

  get action() {
    return this.result.eventAction;
  }

  set label(label) {
    this.result.eventLabel = this.setProperty(label);
  }

  get label() {
    return this.result.eventLabel;
  }

  set value(value) {
    this.result.eventValue = this.setProperty(value);
  }
}
